module.exports = __webpack_public_path__ + "img/zhen.f5a61395.png";